import global from './Global.js';
export default {
  install(Vue, options) {
    Vue.mixin({
      data: function() {
        return {
          CommonUtil:{
            getCodeValue(type, code){
              if(code===null || code==='' || code===undefined){
                return '';
              }
              var codeStr = window.localStorage.getItem(global.SYS_CODE);
              if(codeStr != '' && codeStr != null){
                var codeList = JSON.parse(codeStr);
                var typeList = codeList[type];
                for(var i=0;i<typeList.length;i++){
                  if(typeList[i].code.toString() === code.toString()){
                    return typeList[i].value;
                  }
                }
              }
              return '';
            },
            getCodeList(type){
              var codeStr = window.localStorage.getItem(global.SYS_CODE);
              if(codeStr != '' && codeStr != null){
                var codeList = JSON.parse(codeStr);
                return codeList[type];
              }
              return [];
            },
            getIntCodeList(type){
              var codeStr = window.localStorage.getItem(global.SYS_CODE);
              var res = [];
              if(codeStr != '' && codeStr != null){
                var codeList = JSON.parse(codeStr);
                res = codeList[type];
              }
              for(var i=0;i<res.length;i++){
                res[i].code = parseInt(res[i].code);
              }
              return res;
            },
            getUserInfo(){
              var userStr = window.localStorage.getItem(global.USER_INFO);
              if(userStr != '' && userStr != null){
                var userInfo = JSON.parse(userStr);
                return userInfo;
              }
              return null;
            },
            hasButtonAccess(accessStr){
              var buttonAccess = window.localStorage.getItem(global.USER_AUTH_BUTTOM);
              if(accessStr != '' && accessStr != null && buttonAccess != '' && buttonAccess != null && buttonAccess != undefined && buttonAccess.indexOf(accessStr) > -1){
                return true;
              }else{
                return false;
              }
            },
            isNotNull(obj){
              if(obj != undefined && obj != null && obj != ''){
                return true;
              }else{
                return false;
              }
            },
            setLocalStorage(key, obj){
              if(obj != undefined && obj != null && obj != ''){
                var objStr = JSON.stringify(obj);
                // localStorage.removeItem();
                try {
                  localStorage.setItem(key, JSON.stringify(storeObj));
                } catch (e) {
                  // sessionStorage容量不够，根据保存的时间删除已缓存到 sessionStorage
                  // if (e.name.toUpperCase().indexOf('QUOTA') >= 0) {
                  //   let item;
                  //   const tempArr = [];
                  //   // 先把所有的缓存对象来出来，放到 tempArr 里
                    
                  //   for (item in sessionStorage) {
                  //     if (item.indexOf(cachePrefix) === 0) {
                  //       tempArr.push(JSON.parse(sessionStorage[item]));
                  //     }
                  //   }
                  //   // 如果有缓存对象
                  //   if (tempArr.length) {
                  //     // 按缓存时间升序排列数组
                  //     tempArr.sort((a, b) => a.stamp - b.stamp);
                  //     // 删除缓存时间最早的
                  //     sessionStorage.removeItem(tempArr[0].key);
                  //     // 删除后在再添加，利用递归完成
                  //     addSessionStorage(key, storeObj);
                  //   }
                  // }
                }
              }
            }


          }
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/CommonUtil.js